<div class="priceBundle">
  <p class="title">{{ priceObject.title }}</p>
  <div class="price"><span class="number">$14,90 </span>&nbsp;<span class="textprice"> /month</span></div>

  <div class="main">
    <div class="mainmain">
      <div class="mainText" *ngFor="let item of priceObject['mainPoints']">
        <img src="../../../../assets/images/check.svg" />
        <p>{{ item }}</p>
      </div>
    </div>

    <div class="secondText">
      <img src="../../../../assets/images/checkgreen.svg" />
      <p>All payment methods</p>
    </div>

    <div class="cta">Contact sales</div>
  </div>
</div>
